import React from 'react';
import { Page } from '../Page';
export function PageMealTiming() {
  return <Page pageNumber={22} variant="light" data-id="element-1068">
      <div className="flex flex-col h-full" data-id="element-1069">
        {/* Accent image strip */}
        <div className="h-[160px] -mx-12 -mt-10 mb-8 overflow-hidden relative" data-id="element-1070">
          <img src="https://images.unsplash.com/photo-1495521821757-a1efb6729352?w=1000&q=80" alt="Meal preparation in kitchen" className="w-full h-full object-cover object-center" data-id="element-1071" />
          <div className="absolute inset-0 bg-gradient-to-t from-[#F5F5F0] via-transparent to-transparent" data-id="element-1072" />
        </div>

        <div className="mb-8" data-id="element-1073">
          <p className="text-[10px] font-bold text-tealslate uppercase tracking-[0.2em] mb-3" data-id="element-1074">
            The Essentials
          </p>
          <h1 className="text-5xl font-serif text-[#1F1F1F] leading-tight mb-4" data-id="element-1075">
            When and How
            <br data-id="element-1076" />
            <span className="text-tealslate" data-id="element-1077">Often to Eat</span>
          </h1>
          <div className="w-16 h-0.5 bg-tealslate" data-id="element-1078" />
        </div>

        <p className="text-sm text-[#3B3B3B] leading-[1.8] mb-10 max-w-lg" data-id="element-1079">
          Because GLP-1 medications slow digestion, eating three large meals a
          day often leads to severe bloating, nausea, and acid reflux. You need
          to change how you structure your meals.
        </p>

        <div className="space-y-5 mb-10" data-id="element-1080">
          {[{
          num: '1',
          title: 'Eat Smaller, More Frequent Meals',
          text: 'Instead of 3 large meals, aim for 4-5 smaller meals or snacks throughout the day. This prevents your stomach from becoming overly full and reduces the risk of nausea.'
        }, {
          num: '2',
          title: 'Stop Eating Before You Feel Full',
          text: 'The fullness signal from your stomach to your brain is delayed. If you eat until you feel completely full, you will feel uncomfortably stuffed 20 minutes later. Stop at 80% full.'
        }, {
          num: '3',
          title: 'Close the Kitchen Early',
          text: 'Because food sits in your stomach longer, eating right before bed is a recipe for severe acid reflux. Stop eating at least 3 hours before you go to sleep.'
        }].map((item, i) => <div key={i} className="flex items-start gap-5" data-id="element-1081">
              <div className="w-8 h-8 rounded-full bg-tealslate flex items-center justify-center shrink-0 mt-0.5" data-id="element-1082">
                <span className="text-sm font-serif text-white font-bold" data-id="element-1083">
                  {item.num}
                </span>
              </div>
              <div data-id="element-1084">
                <h3 className="text-sm font-bold text-[#1F1F1F] mb-1" data-id="element-1085">
                  {item.title}
                </h3>
                <p className="text-xs text-[#7A7A70] leading-[1.8]" data-id="element-1086">
                  {item.text}
                </p>
              </div>
            </div>)}
        </div>

        <div className="flex-1 flex items-end" data-id="element-1087">
          <div className="border-l-4 border-tealslate pl-6 py-3" data-id="element-1088">
            <h3 className="font-bold text-[#1F1F1F] text-sm mb-1" data-id="element-1089">
              What About Calories?
            </h3>
            <p className="text-xs text-[#3B3B3B] leading-[1.8]" data-id="element-1090">
              You already have the calories and energy on your body, stored in
              the form of fat. If you find you can't exercise because you're too
              low on energy, adapt your calorie intake. Otherwise, stay focused
              on the big 5.
            </p>
          </div>
        </div>
      </div>
    </Page>;
}